import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExternalFormsList.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { ExternalFormConfig, ExternalForms_Classes } from "../ExternalFormsTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import ExternalFormsEditor from '../ExternalFormsEditor/ExternalFormsEditor';

class ExternalFormsList extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private className: ExternalForms_Classes;
    private entityID: string;

    private externalFormsTable: MdsLax<InstanceType<typeof StaticTable>>;
    private externalFormsStore: MdsLax<InstanceType<typeof EntityStore<ExternalFormConfig>>>;
    private tableContainer: MdsLax<InstanceType<typeof ExpandableSection>>;

    private setupTable(): void {
        this.externalFormsTable = new StaticTable();
        this.externalFormsTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.externalFormsTable.addCustomRowActionButton("open", lang.hitch(this, this._onClickEditButton), "fas fa-external-link-alt", this.translate("General_Label_Open"));
        this.externalFormsTable.setFormatter(this._tableFormatter);
        this.externalFormsTable.placeAt(this.tableContainer);
        this.externalFormsTable.setupFromStore(this.externalFormsStore);
        this.externalFormsTable.setCyAttribute("ExternalFormsList");
    }

    setup(className: ExternalForms_Classes, entityID: string) {
        this.className = className;
        this.entityID = entityID;

        this._loadData();
    }

    reload(): void {
        this._loadData();
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<ExternalFormConfig>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.tableCellNode;

        switch (name) {
            case "responses":
                node.innerHTML = "" + entity.EL_external_form_result_external_form_config.length;
                return true;
                break;
        }

        return false;
    }

    private _onClickRow(row: StaticTable.StaticTableRow<ExternalFormConfig>): void {
        let entity;
        entity = row.rowGroup.entity;
        this._openEditor(entity);
    }

    private _onClickEditButton(rowGroup: StaticTable.StaticTableRowGroup<ExternalFormConfig>) {
        let entity;
        entity = rowGroup.entity;
        this._openEditor(entity);
    }

    private _openEditor(entity: ExternalFormConfig) {
        let editor = new ExternalFormsEditor();
        editor.setup(entity);
    }

    private _loadData(): void {
        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API__ExternalFormsList_GetData",
            { className: this.className, entityID: this.entityID },
            lang.hitch(this, this._onGetDataResponse),
            lang.hitch(this, this._onGetDataError));
    }

    private _onGetDataResponse(response) {
        this.StandbyStop();

        let layout = response.layouts[0];
        let data = response.data;

        this.externalFormsTable.setLayout(layout);
        this.externalFormsStore.setup(data);

        this.tableContainer.setMarking(data.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onGetDataError(error) {
        this.StandbyStop();
        console.error(error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.externalFormsStore = new EntityStore();
        this.setupTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ExternalFormsList);